// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__aat0D","colCheckbox":"styles_colCheckbox__3Ahqv"};